module.exports = __webpack_public_path__ + "static/media/Hero_Image_Desktop.8b2fcc94.jpg";